<avla-modal
  name="modalPassword"
  type="right"
  [icon]=" !activatedChangePassword && !isValid ? { type: 'class', icon: 'close', class: 'material-symbols-rounded' } : { type: 'class', icon: '', class: 'material-symbols-rounded' }"
  [onClose]="reInit.bind(this)"
>
  <div class="avla_modal_section__header">
    <p class="text-2xl font-semibold text-light-blue mt-16">
      Cambio de contraseña
    </p>
  </div>
  <div class="avla_modal_section__body" [ngClass]="{'max-h-[70vh] overflow-y-scroll pb-40': height < 900}">
    <form *ngIf="!isValid" [formGroup]="passwordForm" class="mt-7">
      <div class="flex mx-4">
        <div class="flex flex-col w-full">
          <div class="flex flex-row mb-4 w-1/2">
            <div class="col-span-1 w-full mr-3">
              <avla-input
                class="avla-input-focus"
                [form]="passwordForm"
                id="oldPassword"
                [icons]="{
                  type: 'class',
                  icon: 'visibility_off',
                  change: 'visibility',
                  class: 'material-symbols-rounded',
                  error: ''
                }"
                type="password"
                label="Contraseña actual"
                [required]="true"
              ></avla-input>
            </div>
          </div>
          <div class="flex flex-row mb-4 w-full">
            <div class="col-span-1 mr-6 w-1/2">
              <avla-input
                class="avla-input-focus"
                [form]="passwordForm"
                [onInput]="checkValid.bind(this)"
                id="newPassword"
                [icons]="{
                  type: 'class',
                  icon: 'visibility_off',
                  change: 'visibility',
                  class: 'material-symbols-rounded',
                  error: ''
                }"
                type="password"
                label="Nueva contraseña"
                [required]="true"
              ></avla-input>
            </div>
            <div class="col-span-1 w-1/2">
              <avla-input
                class="avla-input-focus"
                [form]="passwordForm"
                [onInput]="checkValid.bind(this)"
                id="repeatPassword"
                [icons]="{
                  type: 'class',
                  icon: 'visibility_off',
                  change: 'visibility',
                  class: 'material-symbols-rounded',
                  error: ''
                }"
                type="password"
                label="Repetir contraseña"
                [required]="true"
              ></avla-input>
            </div>
          </div>
          <div *ngIf="this.validPassword !== undefined">
            <div>
              <p class="text-sm font-semibold">
                Seguridad de la contraseña:
                <span
                  [ngClass]="
                    this.validPassword ? 'text-success' : 'text-fail'
                  "
                  >{{ passMessage }}</span
                >
              </p>
            </div>
            <div class="text-end">
              <div *ngIf="validPassword !== undefined">
                <div class="w-64 my-1">
                  <img
                    *ngIf="validPassword"
                    src="./assets/svg/rectangle-green.svg"
                    alt="line"
                  />
                  <img
                    *ngIf="!validPassword"
                    src="./assets/svg/rectangle-red.svg"
                    alt="line"
                  />
                </div>
                <div class="w-64">
                  <span
                    [ngClass]="
                      this.validPassword ? 'text-success' : 'text-fail'
                    "
                    class="ml-auto text-xs font-medium"
                    >{{ this.validPassword ? "Fuerte" : "Débil" }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="this.validPassword !== undefined" class="m-4 rounded-2xl border border-gray-300 p-4 shadow-card-shadow">
        <p class="text-smPlus font-light">Su contraseña debe:</p>
        <p class="text-smPlus font-light"
          [ngClass]="
            this.validLength === undefined
              ? 'text-black'
              : this.validLength
              ? 'text-success'
              : 'text-fail'
          "
        >
          Contener al menos 8 caracteres
        </p>
        <p class="text-smPlus font-light"
          [ngClass]="
            this.validNumber === undefined
              ? 'text-black'
              : this.validNumber
              ? 'text-success'
              : 'text-fail'
          "
        >
          Incluye al menos un número
        </p>
        <p class="text-smPlus font-light"
          [ngClass]="
            this.validUppercase === undefined
              ? 'text-black'
              : this.validUppercase
              ? 'text-success'
              : 'text-fail'
          "
        >
          Incluye al menos 1 letra mayúscula
        </p>
        <p class="text-smPlus font-light"
          [ngClass]="
            this.validSpecial === undefined
              ? 'text-black'
              : this.validSpecial
              ? 'text-success'
              : 'text-fail'
          "
        >
          Incluya al menos 1 carácter especial (!@#$%^&*)
        </p>
      </div>
      <div class="flex flex-row w-full justify-center mt-11">
        <avla-button
          class="avla-btn-primary avla-btn-flat-label-md flat-design-button"
          [disabled]="passwordForm.invalid"
          theme="primary"
          label="Guardar"
          (click)="save()"
        ></avla-button>
      </div>
    </form>
    <div *ngIf="isValid" class="flex flex-col items-center gap-6 mt-4 w-72 mx-auto">
      <img src="./assets/svg/logo-avla.svg" alt="img" class="w-32 h-32" />
      <p class="text-xl font-medium text-center">Contraseña cambiada correctamente</p>
      <p class="text-lg font-light text-center">
        Para continuar deberas entrar nuevamente a tu cuenta
      </p>
      <avla-button class="avla-btn-primary avla-btn-flat-label-md flat-design-button" theme="primary" label="Continuar" (click)="next()" [isFlat]="true"
      >Continuar</avla-button>
    </div>
  </div>
</avla-modal>
